// Haptic taps in the Includ Android app; does nothing on the website or in other apps.
// The app (window.includApp) takes includApp.send('haptic', {kind}), kind one of: tap, light,
// success, error, long_press, toggle_on, toggle_off. Call it at the moment something happens.
// The app makes no taps of its own for page actions. A new add-to-bag path should dispatch
// 'includ:added-to-bag' on document after its add succeeds, or it gets no tap.
import { CartAddEvent } from '@theme/events';

const bridge = window.includApp;

if (bridge) {
  const tap = (kind) => bridge.send('haptic', { kind });

  // 'cart:update' also carries removals and line changes, so only the add event itself counts.
  document.addEventListener(CartAddEvent.eventName, (event) => {
    if (event instanceof CartAddEvent && !event.detail?.data?.didError) tap('success');
  });
  document.addEventListener('quickshop:added-to-cart', () => tap('success'));   // quick-shop-simple.js
  document.addEventListener('quickshop:add-to-cart', () => tap('success'));     // quick-shop.js, after a successful add
  // Every other add path announces itself with this theme event once the add succeeded.
  document.addEventListener('includ:added-to-bag', () => tap('success'));
  // Wishlist, both versions (v2's card and product-page hearts announce only once the server agreed).
  // Moving an item to the bag taps as an add to the bag instead.
  const wishlist = (event) => {
    const action = event.detail?.action;
    if (action === 'move_to_bag') return;
    tap(['remove', 'removed', 'remove_all'].includes(action) ? 'toggle_off' : 'toggle_on');
  };
  document.addEventListener('wishlist:v2:updated', wishlist);
  document.addEventListener('spectrum:wishlist:updated', wishlist);
}
